export default __webpack_public_path__ + "static/media/background-second-block.d3c9f923.svg";